import React, { FC, memo } from 'react';
import ASRModelSelect, {
    TemplateProps as ASRModelSelectProps,
} from 'Component/pages/components/ASRModelSelect';
import { AsrFilterConfig } from 'src/api/types';
import { SecondaryTypeMap } from '../../const';

interface TemplateProps extends Omit<ASRModelSelectProps, 'value' | 'onChange'> {
    sourceType: number;
    value?: AsrFilterConfig;
    onChange?: (v: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { sourceType, value, onChange, ...restProps } = props;

    return (
        <ASRModelSelect
            value={value?.filter?.asrEngineType}
            onChange={(v) =>
                onChange?.({
                    type: 1,
                    sourceType,
                    activeFlag: 1,
                    secondaryType: SecondaryTypeMap.LANG,
                    ...value,
                    filter: { ...value?.filter, asrEngineType: v },
                })
            }
            {...restProps}
        />
    );
});

export default Template;
